module.exports = __webpack_public_path__ + "img/IR.af390237.png";